import { getMessages } from '../../../../../../store/constants';

export const MICROSOFT_GROUP_PERMISSION_TITLE = getMessages().getText('open_boards.blocker.sharedDrives.title');
